module.exports = __webpack_public_path__ + "assets/img/C++.6ebd8a60.jpg";